<!-- SIDEBAR CONTENT -->
<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}">

    <div class="p-24">

    </div>

    <div class="nav material2">
        <div class="nav-item">
            <a class="nav-link" matRipple routerLink="/customers/details/{{user.id}}" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">account_box</mat-icon>
                <span>{{'Summary'|translate}}</span>
            </a>
        </div>
        <div class="nav-item">
            <a class="nav-link" matRipple routerLink="/customers/personal-data/{{user.id}}" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">access_alarm</mat-icon>
                <span>{{'Personal data'|translate}}</span>
            </a>
        </div>
<!--        <div class="nav-item">-->
<!--            <a class="nav-link" matRipple routerLink="/pos/{{user.id}}" [routerLinkActive]="[]">-->
<!--                <mat-icon class="nav-link-icon">receipt</mat-icon>-->
<!--                <span>{{'Open bill'|translate}}</span>-->
<!--            </a>-->
<!--        </div>-->
        <div class="nav-item">
            <a class="nav-link" matRipple routerLink="/customers/cards/{{user.id}}" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">credit_card</mat-icon>
                <span>{{'Cards'|translate}}</span>
            </a>
        </div>
        <div class="nav-item" *ngIf="user.cardsQuantity<1">
            <a class="nav-link" matRipple routerLink="/customers/cards/{{user.id}}/add" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">credit_card</mat-icon>
                <span>{{'Add card'|translate}}</span>
            </a>
        </div>
<!--        <div class="nav-item">-->
<!--            <a class="nav-link" matRipple routerLink="/customers/communication/{{user.id}}" [routerLinkActive]="[]">-->
<!--                <mat-icon class="nav-link-icon">phone</mat-icon>-->
<!--                <span>{{'Communication'|translate}}</span>-->
<!--            </a>-->
<!--        </div>-->
        <div class="nav-item">
            <a class="nav-link" matRipple routerLink="/customers/orders/{{user.id}}" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">shopping_bag</mat-icon>
                <span>{{'Orders'|translate}}</span>
            </a>
        </div>
        <div class="nav-item">
            <a class="nav-link" matRipple routerLink="/customers/reservations/{{user.id}}" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">event_note</mat-icon>
                <span>{{'Reservations'|translate}}</span>
            </a>
        </div>
        <div class="nav-item">
            <a class="nav-link" matRipple routerLink="/customers/notification-history/{{user.id}}" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">event</mat-icon>
                <span>{{'Notification history'|translate}}</span>
            </a>
        </div>

        <div class="nav-item">
            <a class="nav-link" matRipple (click)="newNote()">
                <mat-icon class="nav-link-icon">description</mat-icon>
                <span>{{'Add note'|translate}}</span>
            </a>
        </div>

    </div>

</div>
<!-- / SIDEBAR CONTENT -->
